// @flow

export const ScreenTypes = {
  SMALL_SCREEN: 'SMALL_SCREEN',
  MEDIUM_SCREEN: 'MEDIUM_SCREEN',
  LARGE_SCREEN: 'LARGE_SCREEN'
}
export default { ...ScreenTypes}